import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=21f3cafe&scoped=true"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f3cafe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\moyongpeng-project\\tianyi-crm\\scrm-vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21f3cafe')) {
      api.createRecord('21f3cafe', component.options)
    } else {
      api.reload('21f3cafe', component.options)
    }
    module.hot.accept("./empty.vue?vue&type=template&id=21f3cafe&scoped=true", function () {
      api.rerender('21f3cafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/empty.vue"
export default component.exports